import BossModel from "@/models/BossModel";
import PlatinumHotel from "@/models/PlatinumHotel/PlatinumHotel";

export default class Item extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/hotel-list/item';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetHotelListItems';

    static fields() {
        return {
            id: this.number(null).nullable(),
            platinum_widget_hotel_list_id: this.number(null),
            platinum_hotel_id: this.number(null),
            rank: this.number(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            platinumHotel: this.belongsTo(PlatinumHotel, 'platinum_hotel_id'),
        }
    }
}
